import type { IconSvgObject } from './types';

const CodepenIcon: IconSvgObject = [
  ["path", { d: "M12 9.5V2.5L22 8.5V15.5L12 9.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 9.5V2.5L2 8.5V15.5L12 9.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M12 14.5V21.5L22 15.5V8.5L12 14.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M12 14.5V21.5L2 15.5V8.5L12 14.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default CodepenIcon;
